<template>
  <div>
<InventoryPageHeader>
  <template #title>
    <router-link to="/devices" class="btn btn-sm btn-outline-secondary mr-2">
      <i class="fas fa-arrow-left"></i>
    </router-link>
    Batch Details
  </template>
</InventoryPageHeader>

    <b-container fluid class="mt--6">
      <b-card no-body class="card-shadow mb-4" v-if="batch">
        <b-card-header><i class="fas fa-box mr-2"></i>Batch {{ batch.number }}</b-card-header>
        <b-card-body>
          <b-row>
            <b-col md="6">
              <dl class="row">
                <dt class="col-sm-4">Quantity</dt><dd class="col-sm-8">{{ batch.quantity }}</dd>
                <dt class="col-sm-4">Characteristics</dt><dd class="col-sm-8">{{ batch.characteristics }}</dd>
              </dl>
            </b-col>
            <b-col md="6">
              <dl class="row">
                <dt class="col-sm-4">Delivery Date</dt><dd class="col-sm-8">{{ batch.deliveryDate }}</dd>
                <dt class="col-sm-4">History</dt><dd class="col-sm-8">{{ batch.history }}</dd>
              </dl>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>

      <b-card no-body class="card-shadow">
        <b-card-header><i class="fas fa-tablet-alt mr-2"></i>Devices in this Batch</b-card-header>
        <b-card-body class="p-0 table-responsive">
          <el-table :data="devices" @row-click="goToDevice" row-class-name="cursor-pointer" style="width:100%;" empty-text="No devices found">
            <el-table-column label="MAC">
              <template slot-scope="{ row }">
                <router-link :to="`/devices/${row.mac}`" class="text-primary font-weight-bold">{{ row.mac }}</router-link>
              </template>
            </el-table-column>
            <el-table-column label="Location">
              <template slot-scope="{ row }">
                <router-link :to="`/companies/${encodeURIComponent(row.currentLocation)}`" class="text-primary">{{ row.currentLocation }}</router-link>
              </template>
            </el-table-column>
            <el-table-column label="Status">
              <template slot-scope="{ row }">
                <b-badge :variant="row.currentStatus.startsWith('RMA') ? 'danger' : (row.currentStatus === 'OK' ? 'success' : 'secondary')">{{ row.currentStatus }}</b-badge>
              </template>
            </el-table-column>
          </el-table>
        </b-card-body>
      </b-card>
    </b-container>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import InventoryPageHeader from '@/components/InventoryPageHeader.vue'

export default {
  name: 'BatchDetail',
components: { InventoryPageHeader },

  props: ['number'],
  computed: {
    ...mapState('inventory', ['batches']),
    ...mapGetters('inventory', ['devicesByBatch']),
    batch() { return this.batches.find(b => b.number === this.number) },
    devices() { return this.devicesByBatch(this.number) }
  },
  mounted() {
    this.$store.dispatch('inventory/loadBatches')
    this.$store.dispatch('inventory/loadDevices')
  },
  methods: {
    goToDevice(row) { this.$router.push({ name: 'deviceDetail', params: { mac: row.mac } }) }
  }
}
</script>